module.exports = __webpack_public_path__ + "static/media/aboutBg.6f22aa52.jpg";